<form [formGroup]="form">
  <ng-container [formGroupName]="'date'">
    <mat-form-field class="holder">
      <mat-label>Year</mat-label>
      <input matInput formControlName="Y" min="0" type="number" />
    </mat-form-field>
    <mat-form-field class="holder">
      <mat-label>Month</mat-label>
      <input matInput formControlName="M" min="0" type="number" />
    </mat-form-field>
    <mat-form-field class="holder">
      <mat-label>Week</mat-label>
      <input matInput formControlName="W" min="0" type="number" />
    </mat-form-field>
    <mat-form-field class="holder">
      <mat-label>Day</mat-label>
      <input matInput formControlName="D" min="0" type="number" />
    </mat-form-field>
  </ng-container>
  <ng-container [formGroupName]="'time'">
    <span class="separate"><mat-icon>access_time</mat-icon></span>
    <mat-form-field class="holder">
      <mat-label>Hour</mat-label>
      <input matInput formControlName="H" min="0" max="23" type="number" />
    </mat-form-field>
    <span class="separate">:</span>
    <mat-form-field class="holder">
      <mat-label>Minute</mat-label>
      <input matInput formControlName="M" min="0" max="59" type="number" />
    </mat-form-field>
  </ng-container>
</form>
<div class="value">
  <span class="separate">=</span>
  <mat-form-field class="holder">
    <mat-label>Value</mat-label>
    <input matInput [formControl]="value" min="0" max="59" type="text" />
  </mat-form-field>
</div>
<!-- <mat-label
  ><span [class.select]="!custom">Duration Value</span> /
  <span [class.select]="custom">Custom Duration</span></mat-label
>
<div class="custom">
  <input matInput class="custom" type="text" [formControl]="value" />
</div> -->
